import ScorecardSummaryRowHoleScoreCell from "./ScorecardSummaryRowHoleScoreCell";
import ScorecardSummaryRowPlayerNameCell from "./ScorecardSummaryRowPlayerNameCell";
import ScorecardSummaryRowTotalScoreCell from "./ScorecardSummaryRowTotalScoreCell";

function ScorecardRow({ item, throwScoringModeId }) {
  //sort this row of scores
  const thisRowScoresSorted = item.hole_scores.sort((a, b) => {
    return a.layout_holes.hole_order - b.layout_holes.hole_order;
  });

  const thisRowsScoreTotal = thisRowScoresSorted.reduce((a, b) => {
    return a + b.score;
  }, 0);

  const thisRowsScoreAdvTotal = thisRowScoresSorted.reduce((a, b) => {
    return a + b.hole_score_adv;
  }, 0);

  let isEmptyHole = "false";

  item.hole_scores.forEach((score, index) => {
    if (score.score === null) {
      isEmptyHole = "true";
    }
  });

  return (
    <tr>
      <ScorecardSummaryRowPlayerNameCell player={item.users_public.name} />

      {thisRowScoresSorted.map((hole, holeIndex) => (
        <ScorecardSummaryRowHoleScoreCell
          score={hole}
          index={holeIndex}
          throwScoringModeId={throwScoringModeId}
          key={holeIndex}
        />
      ))}

      <ScorecardSummaryRowTotalScoreCell
        total={thisRowsScoreTotal}
        isDnf={item.is_dnf}
        isEmptyHole={isEmptyHole}
        needsLeftBorder={true}
      />

      {throwScoringModeId > 1 && (
        <ScorecardSummaryRowTotalScoreCell
          total={thisRowsScoreAdvTotal}
          isDnf={item.is_dnf}
          isEmptyHole={isEmptyHole}
          needsLeftBorder={false}
        />
      )}
    </tr>
  );
}

export default ScorecardRow;
